import { PERMISSION_REQUEST_ERRORS } from '../../enums/permission_request_error.enum';
import { GranteeIneligibleReasons } from '../../../common/enums/ineligible-scenarios.enum';

export enum ErrorPage {
    TECH_DIFF,
    GRANTEE_CANT_COMPLETE_ONLINE,
    GRANTEE_PIN_EXPIRED,
    GRANTEE_TOO_MANY_ATTEMPTS,
    GRANTEE_HAS_PENDING_REQUEST,
    GRANTEE_FOREIGN_ADDRESS,
    GRANTEE_LINK_EXPIRED,
    ACCEPT_ACCESS_FLOW_PARTIAL_SUCCESS,
    ACCEPT_ACCESS_FLOW_SUBMIT_ALL_FAILED,
}

export const errorPageMap: Partial<Record<PERMISSION_REQUEST_ERRORS, ErrorPage>> = {
    [PERMISSION_REQUEST_ERRORS.RECORD_NOT_FOUND]: ErrorPage.TECH_DIFF,
    [PERMISSION_REQUEST_ERRORS.RECORD_EXPIRED]: ErrorPage.GRANTEE_PIN_EXPIRED,
    [PERMISSION_REQUEST_ERRORS.TOO_MANY_ATTEMPTS]: ErrorPage.GRANTEE_TOO_MANY_ATTEMPTS,
    [PERMISSION_REQUEST_ERRORS.ALREADY_HAS_ACCESS]: ErrorPage.GRANTEE_LINK_EXPIRED,
};

export const granteeIneligibleReasonPageMap: Partial<Record<GranteeIneligibleReasons, ErrorPage>> = {
    [GranteeIneligibleReasons.FOREIGN_ADDRESS]: ErrorPage.GRANTEE_FOREIGN_ADDRESS,
    [GranteeIneligibleReasons.ASSOCIATED_OR_CONTROL_PERSON]: ErrorPage.GRANTEE_CANT_COMPLETE_ONLINE,
};
